import RefreshTravellerDetailsPopup from './refresh-traveller-details-popup-component';
import './refresh-traveller-details-popup.scss';
import RefreshTravellerDetailsService from './refresh-traveller-details-service';

const MODULE_NAME = 'refresh-traveller-details-popup';
const module = angular.module(MODULE_NAME, [])
    .directive(RefreshTravellerDetailsPopup.DIRECTIVE_NAME, RefreshTravellerDetailsPopup)
    .service('refreshTravellerDetailsService', RefreshTravellerDetailsService);
export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/travellers/refresh-traveller-details-popup/refresh-traveller-details-popup-module.js